/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportWrapper_reports = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportWrapper_reports",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ReportHeader_reports",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserReportGrid_reports",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AdminReportGrid_reports",
      "args": null
    }
  ],
  "type": "ReportConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/__generated__/ReportWrapper_reports.graphql.js